"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyDetailResponse$ = exports.PropertyDetailResponse$outboundSchema = exports.PropertyDetailResponse$inboundSchema = void 0;
exports.propertyDetailResponseToJSON = propertyDetailResponseToJSON;
exports.propertyDetailResponseFromJSON = propertyDetailResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const propertywrapper_js_1 = require("./propertywrapper.js");
/** @internal */
exports.PropertyDetailResponse$inboundSchema = z.object({
    data: propertywrapper_js_1.PropertyWrapper$inboundSchema,
});
/** @internal */
exports.PropertyDetailResponse$outboundSchema = z.object({
    data: propertywrapper_js_1.PropertyWrapper$outboundSchema,
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PropertyDetailResponse$;
(function (PropertyDetailResponse$) {
    /** @deprecated use `PropertyDetailResponse$inboundSchema` instead. */
    PropertyDetailResponse$.inboundSchema = exports.PropertyDetailResponse$inboundSchema;
    /** @deprecated use `PropertyDetailResponse$outboundSchema` instead. */
    PropertyDetailResponse$.outboundSchema = exports.PropertyDetailResponse$outboundSchema;
})(PropertyDetailResponse$ || (exports.PropertyDetailResponse$ = PropertyDetailResponse$ = {}));
function propertyDetailResponseToJSON(propertyDetailResponse) {
    return JSON.stringify(exports.PropertyDetailResponse$outboundSchema.parse(propertyDetailResponse));
}
function propertyDetailResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PropertyDetailResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PropertyDetailResponse' from JSON`);
}
//# sourceMappingURL=propertydetailresponse.js.map